jQuery(document).ready(function($) {
    init_calendar($);
    if($('body').find('[data-squde-calendar]').length == 0) {
        return;
    }
    if(!is_dev) {
        return;
    }
    // view_appointment(238);
    // $('[data-squde-calendar]').bind('calendar-loaded', function() {
    //     $('.filters-button[data-filters="default"]').click();
    // });
});
function init_calendar($, by_reloader) {

    if($('body').find('[data-squde-calendar]').length == 0) {
        return;
    }

    let module = localStorage.getItem('calendar-module');
    if ( module === undefined || module === null ) {
        module = 'courses';
    }
    window.module = module;

    localStorage.setItem('calendar-module','courses');

    $('[data-squde-calendar]').bind('calendar-loaded', function() {

        $(this).find('.appointment-wrapper').unbind('mouseenter').mouseenter(function(mouse_event) {
            var e = $(this);
            if(e[0].info_box_timeout != undefined) {
                clearTimeout(e[0].info_box_timeout);
            }
            e[0].info_box_timeout = setTimeout(function() {
                open_info_box(e, mouse_event);
            },500);
        }).unbind('mouseleave').mouseleave(function() {

            var e = $(this);
            if(e[0].info_box_timeout != undefined) {
                clearTimeout(e[0].info_box_timeout);
            }
            var info_box = e[0].infoBox;
            if(info_box && info_box.length > 0) {
                info_box.remove();
            }
        });
    });

    $('[data-squde-calendar]').squdeNiceCalendar({
        loadData: function(elm, type, filters) {
            elm.isLoading();
            filters.type = type;
            filters.module = module;
            $.ajax({
                url: '/ajax/getAppointments/' + module,
                dataType: 'JSON',
                type: 'GET',
                data: filters,
                success: function(data) {
                    $.each(data, function(key, value) {
                        data[key]['start_datetime'] = new Date(value.start_datetime * 1000)

                        data[key]['end_datetime'] = new Date(value.end_datetime * 1000)
                    });
                    elm.setAppointments({
                        'dates':data,
                        'createAppointmentHtml': function(appointment, type) {
                            if (module === 'courses') {
                                return get_course_appointment_html(appointment, type);
                            } else {
                                return get_inspections_html(appointment, type);
                            }
                        },
                        'onOpen': function(elm, col) {
                            var id = col.attr('data-id');
                            view_appointment(id);
                        }
                    });
                    elm.doneLoading();
                    elm.trigger('calendar-loaded');
                },
                error: function(e) {
                    console.log(e);
                    elm.doneLoading();
                }
            })
        },
        onAdd: function(elm, datetime) {
            add_appointment(datetime, elm, elm.attr('data-calendar-type'));
        },
        filters: {
            names: {
                'course_id': 'Cursus',
                'instructor_id' : 'Docent',
                'not_full': "Volgepland weglaten",
                // 'exclusive': "Alleen in-company",
                'incompany': "In-company",
                'status': "Status",
                'establishment_id': "Vestiging",
                'room_id': "Lokaal",
                'tasks': 'Taken',
                'company_id': "Bedrijf",
                'appointment_group_id': "Nummer",
            },
            onOpen: function(setFilters, curFilters, filtersKey) {
                var size = filtersKey === 'default' ? 'medium' : 'large';

                $.squdeAjaxPopup({
                    url: '/calendar/filters/'+filtersKey,
                    size: size,
                    onOpen: function(elm, popup) {

                        elm.find('#course_id').courseSelector();
                        elm.find('.contact-selector').contactSelector();
                        elm.find('#company_id').companySelector();

                        if(curFilters !== null) {
                            curFilters = JSON.parse(curFilters);
                            for(let key in curFilters) {
                                let value = curFilters[key];
                                let input = elm.find(':input#' + key.split('_').join('-'));
                                if (input.length === 0) {
                                    input = elm.find(':input#' + key);
                                }
                                if(input.length > 0) {
                                    input.unbind('change.calendar');

                                    if(input.hasClass('has-special-selector')) {
                                        if (parseInt(value) > 0) {
                                            input.setValue(value);
                                        }
                                    } else if(input.is(':checkbox') && value === input.attr('value')) {
                                        input.attr('checked','checked');
                                    } else {
                                        input.val(value).trigger('change');
                                    }
                                } else {
                                    elm.find('form').prepend('<input type="hidden" name="'+key+'" id="'+key+'" value="'+value+'" />');
                                }
                            }
                        }


                        elm.find('form').submit(function(e) {
                            e.preventDefault();

                            setFilters($(this).serializeJSON(), $(this));

                            popup.close();
                        });
                    }
                });
            }
        }
    });
}
function add_appointment(datetime, calendar_div, type) {
    const $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: '/calendar/add',
        data: {
            datetime: datetime.getTime() / 1000,
            type: calendar_div.attr('data-calendar-type')
        },
        onOpen: function(elm,popup) {
            elm.find('[data-course-selector]').courseSelector();
            const submit_button = elm.find('[type=submit]');


            (async () => {
                const contacts = await $.get('/ajax/specialSelectorSearch', {
                    type: 'contact',
                    limit: 1000,
                    returnObjects: true,
                    with: [
                        'roles',
                        'skills'
                    ],
                    filters: {
                        roles: [
                            'teacher',
                            'lotus',
                        ]
                    }
                });

                elm.find('select#new-appointment-course').change(function() {
                    //$(this).find('option[value=0]').remove();
                    const v = $(this).val();
                    if(v < 1 || isNaN(v)) {
                        return;
                    }
                    submit_button.attr('disabled',true);

                    $.ajax({
                        url: '/ajax/getCourse/'+v,
                        dataType: 'JSON',
                        success: function(course) {
                            elm.find('.is-online').toggle(course.online === 1);
                            elm.find('.is-offline').toggle(course.online === 0);

                            if(course.components.length > 0) {
                                initiateComponentLogic(elm, {
                                    course,
                                    contacts,
                                    datetime,
                                    type,
                                });
                            } else {
                                submit_button.attr('disabled',false);
                                elm.find('.course-components-appointments').hide();
                            }

                            elm.find('input[name="max_count"]').val(course.last_max_count);

                            var choose_course_form = elm.find('form.choose_course');
                            choose_course_form.ajaxFormSubmit(function(data) {
                                    choose_course_form.doneLoading();
                                    elm.find('.teachers-for-appointments-wrapper').html(data);

                                    init_edit_responsible_times(elm);

                                    elm.find('a.add-person').click(function() {
                                        add_contact({
                                            callback: function(contactObj, popupElm, popupObject) {
                                                popupObject.close();
                                                setTimeout(function() {
                                                    ajax_popup_scroll_to_previous_screen(function() {
                                                        choose_course_form.submit();
                                                    });
                                                },500);
                                            }.bind([choose_course_form])});
                                    });
                                    ajax_popup_scroll_to_next_screen();
                                }.bind([choose_course_form, elm]),
                                function(e) {
                                    choose_course_form.doneLoading();
                                    var arr = JSON.parse(e.responseText);
                                    var date_problem = false;
                                    for(var key in arr) {
                                        var p = key.split('.');
                                        if(p[0] == 'appointments' && (p[2] == 'start_datetime' || p[2] == 'end_datetime')) {
                                            const fieldset = choose_course_form.find('.course-components-appointments-wrapper fieldset:eq('+p[1]+')');
                                            fieldset.find('.dates-wrapper a').addClass('is-invalid-label');
                                            fieldset.find('input').bind('change.removeInvalidLabel', function() {
                                                fieldset.find('.is-invalid-label').removeClass('is-invalid-label');
                                                fieldset.find('.dates-wrapper input').unbind('change.removeInvalidLabel');
                                            });
                                            date_problem = true;
                                        }
                                    }
                                    var str = "Er ging iets mis...";
                                    if(date_problem === true) {
                                        str = "Begindatum moet voor de einddatum zijn.";
                                    }
                                    squde_flash(str, "alert");

                                }.bind([choose_course_form]), function() {
                                    choose_course_form.isLoading();
                                    choose_course_form.find('.is-invalid-label').removeClass('is-invalid-label');
                                }.bind([choose_course_form]));

                            var load_address_screen = function() {
                                var send_data = elm.find('form.choose_course').serializeJSON();
                                if(elm.find('input[name="incompany"][value="1"]').is(':checked')) {
                                    var obj2 = elm.find('form.incompany').serializeJSON();
                                    for (var attrname in obj2) { send_data[attrname] = obj2[attrname]; }
                                }
                                send_data.appointments = Object.values(send_data.appointments).filter((appointment) => {
                                    return appointment.enabled === '1';
                                });

                                const justOneAppointment = send_data.appointments.length === 1;
                                const onlineOfflineSelector = `is-${course.online ? 'online' : 'offline'}`;
                                elm.find(`div.same-location-question.${onlineOfflineSelector}, p.same-location-question`).toggle(!justOneAppointment);
                                const sameLocationY = elm.find('input[name="same_location"][value="1"]');
                                const sameLocationN = elm.find('input[name="same_location"][value="0"]');
                                const sameOnlineLocationY = elm.find('input[name="same_online_details"][value="1"]');
                                const sameOnlineLocationN = elm.find('input[name="same_online_details"][value="0"]');
                                sameLocationY[0].disabled = false;
                                if (justOneAppointment) {
                                    sameLocationY[0].checked = true;
                                    sameLocationN[0].checked = false;
                                    sameOnlineLocationY[0].checked = true;
                                    sameOnlineLocationN[0].checked = false;
                                } else if (!course.online) {
                                    let different_rooms = [];

                                    for(const key in send_data.appointments) {
                                        const appt = send_data.appointments[key];
                                        if(different_rooms.indexOf(appt.room_id) < 0) {
                                            different_rooms.push(appt.room_id);
                                        }
                                    }

                                    if(different_rooms.length > 1) {
                                        sameLocationY[0].checked = false;
                                        sameLocationN[0].checked = true;
                                        sameLocationY[0].disabled = true;
                                    }
                                }


                                send_data.all_the_same = sameLocationY.is(':checked') ? 1 : 0;
                                send_data.all_the_same_online = sameOnlineLocationY.is(':checked') ? 1 : 0;
                                send_data.online = course.online;

                                $.post('/calendar/addAddress', send_data, function(html) {
                                    elm.find('.address-form-wrapper').html(html);

                                    elm.find('.location-option-select').trigger('change');

                                    elm.find('[data-nibhv_location-selector]').nibhvLocationSelector();
                                });
                            };

                            let saved_selected_company_inputs = '';
                            let incompany_wrapper = elm.find('.incompany-wrapper');
                            const submitInCompanyButton = elm.find('.submit-incompanies');
                            elm.find('input[name=incompany]').unbind('change').change(function() {
                                const scrollScreen = $(this).parents('.scroll-screen');
                                if(parseInt($(this).val()) === 1) {
                                    incompany_wrapper.html(saved_selected_company_inputs);
                                    submitInCompanyButton[0].disabled = incompany_wrapper.children().length === 0;
                                } else {
                                    saved_selected_company_inputs = incompany_wrapper.html();
                                    incompany_wrapper.empty();
                                }
                            });
                            elm.find('.incompanies-list').unbind('onReload').bind('onReload', function() {
                                const table = $(this);
                                table.find('input[type=checkbox]:not(.check-whole-table)').bind('change.updateList', function() {
                                    incompany_wrapper.empty();
                                    table.find('input[type=checkbox]:not(.check-whole-table):checked').each(function() {
                                        const v = $(this).val();
                                        const hiddenInput = $(`<input name="selected_company_ids[]" type="hidden" value="${v}" />`);
                                        incompany_wrapper.append(hiddenInput);
                                    });
                                    submitInCompanyButton[0].disabled = incompany_wrapper.children().length === 0;
                                });
                                const allCheckbox = table.find('.check-whole-table')[0];
                                if (allCheckbox) {
                                    allCheckbox.checked = true;
                                    checkWholeTable(allCheckbox);
                                }
                                // table.find('input[type=checkbox]:first').trigger('change.updateList');

                            }).reloadThisElement();

                            if (course.group_product_id && elm.find('input[name="use_invoice_relation"]:checked')[0]) {
                                elm.find('.invoice-relations-options').show();
                                elm.find('select[name="invoice_relation_id"], input[name="use_invoice_relation"]').unbind('change').change(function() {
                                    const useInvoiceRelation = parseInt(elm.find('input[name="use_invoice_relation"]:checked:not([disabled])').val()) === 1;
                                    const v = useInvoiceRelation ? $('select[name="invoice_relation_id"]').val() : '';
                                    elm.find('.extra-wrapper input[name="invoice_relation_id"]').val(v);
                                });
                                toggle_appointment_invoice_relation(elm.find('input[name="use_invoice_relation"]:checked')[0]);
                            } else {
                                elm.find('.invoice-relations-options').hide();
                                elm.find('.extra-wrapper input[name="invoice_relation_id"]').val('');
                            }


                            elm.find('form.incompany').ajaxFormSubmit(function() {
                                load_address_screen();

                                ajax_popup_scroll_to_next_screen();
                            });


                            let saved_selected_location_inputs = '';
                            let saved_selected_location_online_inputs = '';
                            let location_wrapper = elm.find('.location-wrapper');

                            elm.find('.scroll-screen:has(form.address)').prev('.scroll-screen').bind('beforeScroll', function() {
                                load_address_screen();
                            });

                            elm.find('input[name=same_location]').unbind('change').change(function() {
                                if(parseInt($(this).val()) === 1) {
                                    location_wrapper.html(saved_selected_location_inputs);
                                } else {
                                    saved_selected_location_inputs = location_wrapper.html();
                                    location_wrapper.empty();
                                }
                                load_address_screen();
                            });
                            elm.find('input[name=same_online_details]').unbind('change').change(function() {
                                if(parseInt($(this).val()) === 1) {
                                    location_wrapper.html(saved_selected_location_online_inputs);
                                } else {
                                    saved_selected_location_online_inputs = location_wrapper.html();
                                    location_wrapper.empty();
                                }
                                load_address_screen();
                            });
                            elm.find('form.address').ajaxFormSubmit(function(data, form) {
                                location_wrapper.empty();
                                form.find(':input[name]').each(function() {
                                    const clone = $(this).clone();
                                    location_wrapper.append(clone);
                                    clone.val($(this).val());
                                });
                                ajax_popup_scroll_to_next_screen();
                            });

                            var submit_new_appointments_form = elm.find('form.choose_teachers');
                            submit_new_appointments_form.find('[type="submit"]').unbind('click').removeClass('clicked').click(function() {
                                $(this).addClass('clicked');
                            });
                            submit_new_appointments_form.ajaxFormSubmit(function(data) {
                                submit_new_appointments_form.doneLoading();

                                popup.close();
                                if (submit_new_appointments_form.find('.clicked').attr('name') === 'add-new-appointment') {
                                    data = JSON.parse(data);

                                    let afterLoading;
                                    afterLoading = setInterval(() => {
                                        if ($('.loading-indicator-wrapper:visible').length === 0) {
                                            clearInterval(afterLoading);

                                            view_appointment(data[0].id);
                                        }
                                    }, 250);
                                }
                                calendar_div.reloadNiceCalendar();
                            }.bind([submit_new_appointments_form, popup]),undefined,function() {
                                submit_new_appointments_form.isLoading();
                            }.bind([submit_new_appointments_form]));
                        }.bind([datetime, type, submit_button])
                    });
                });
            })();

        }.bind([datetime, type])
    });
}
function add_students(course_id, reservations, filters) {
    if(reservations == undefined) {
        reservations = false;
    }
    if(filters == undefined) {
        filters = {};
    }
    var $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: '/calendar/enroll/'+course_id+'/'+reservations,
        onOpen: function (elm, popup) {
            if(!filters.company_id) {
                filters.company_id = -1;
            }
            $('select#company_id').companySelector(filters.company_id);
            const students_form = $('.select_students_form');

            $(elm).find('[data-add-contact-button]').click(function() {
                add_contact({reload_item: $('.new-students-table')});
                return false;
            });

            const reload_new_students_table = function() {
                $('.new-students-table').reloadThisElement(function() {
                    // $('.new-students-table').find('input[type=checkbox]').change(function() {
                    //     var table = $(this).parents('.new-students-table');
                    //     if(table[0].waitForReload) {
                    //         clearTimeout(table[0].waitForReload);
                    //     }
                    //     table[0].waitForReload = setTimeout(function() {
                    //         reload_new_students_table();
                    //     },50);
                    // });
                });
            };
            reload_new_students_table();

            students_form.ajaxFormSubmit(function(data) {
                $('body').doneLoading();
                $('.selected-students-wrapper').html(data);
                if(!students_form.hasClass('single')) {
                    ajax_popup_scroll_to_next_screen();
                }
            },function() {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            },function() {
                $('body').isLoading('dark');
            });


            if(students_form.hasClass('single')) {
                students_form.submit();
            }

            $('.enroll_students_form').ajaxFormSubmit(function(data) {
                //$('body').doneLoading();
                //ajax_popup_scroll_to_previous_screen();
                //console.log(data);
                // popup.close();

                squde_reload_for_flashes(function() {
                    reload_location_if_needed();
                });
            }, function(e) {
                $('body').doneLoading();
                if(e.responseJSON.students) {
                    ajax_popup_scroll_to_previous_screen();
                    reload_new_students_table();
                } else {
                    squde_flash("Er ging iets mis bij het opslaan.","alert");
                }
            }, function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function open_info_box(appointment, mouse_event) {
    var $ = jQuery.noConflict();
    // console.log(appointment.attr('data-id'));
    var id = get_unique_id();
    $('body').append('<div class="info-box-wrapper" id="'+id+'">' +
        '<div class="info-box-container">' +
        '</div></div>');

    var info_box = $('#'+id);
    var c = info_box.find('.info-box-container');
    c.empty();


    var active_type = $('[data-calendar-type-button].active').attr('data-calendar-type-button');


    var l = appointment.offset().left;
    var t = appointment.offset().top;
    var w = 200;
    if(active_type == 'l') {
        l = mouse_event.pageX;
        t = mouse_event.pageY;
    } else {
        w =  appointment.parents('.calendar-column').outerWidth(true);
    }

    info_box.css({
        'width': w,
        'left': l,
        'top': t
    });
    if(l > $(window).width() / 2 || active_type == 'l') {
        info_box.addClass('to-left');
    }

    c.isLoading();
    appointment[0].infoBox = info_box;
    if(appointment[0].infoBoxAjax) {
        appointment[0].infoBoxAjax.abort();
    }
    appointment[0].infoBoxAjax = $.getJSON({
        url: '/calendar/ajaxGetAppointment/' + appointment.attr('data-id') + '/' + 'courses',
        success: function(data) {
            c.doneLoading();

            fill_course_info_box(c, data);
        }
    });

    //Little fix that keeps it from hanging
    info_box.mouseenter(function() {
        $(this).mouseleave(function() {
            $(this).remove();
        });
    })
}
function view_appointment(id) {
    const $ = jQuery.noConflict();
    // Prevent info-boxes from showing up over the appointment screen
    $('.info-box-wrapper').remove();
    $.squdeAjaxPopup({
        url: '/calendar/view-appointment/'+id,
        //options: get_view_appointment_options(id),
        onOpen: function(elm, popup) {
            const appointmentId = elm.find('select[name="appointment_id"]').val();
            init_documents_filters(elm);

            init_notes_editing(elm);

            elm.find('.subscribed-contacts-table').bind('onReload', function() {
                const table = $(this);
                const subscribeButton = table.next();
                const reservationButton = subscribeButton.next();
                table.find('input[name="notes"]').bind('keyup paste', function() {
                    const input = $(this);
                    if (input[0].timeout) {
                        clearTimeout(input[0].timeout);
                    }
                    input[0].timeout = setTimeout(() => {
                        const value = input.val();
                        const id = input.parents('tr').attr('data-id');
                        save_student_notes(appointmentId, id, value);
                    }, 1000);
                });

                table.find(':checkbox').change(function() {
                    const canRemoveOrMove = table.find(':checkbox:checked').length > 0;

                    const form = $('<form></form>');
                    table.find(':checkbox').clone(true,true).appendTo(form);
                    const data = (form.serializeJSON().students || []).map((str) => parseInt(str));
                    const ids = JSON.stringify(data);

                    const subscribeText = canRemoveOrMove ? 'Uitschrijven' : 'Inschrijven';
                    const subscribeAction = canRemoveOrMove ? `mass_unsubscribe(${appointmentId}, ${ids})` : `add_students(${appointmentId})`;
                    const moveText = canRemoveOrMove ? 'Cursisten verplaatsen': 'Reserveren';
                    const moveAction = canRemoveOrMove ? `mass_move_students(${appointmentId}, ${ids})`: `make_reservation(${appointmentId})`;

                    subscribeButton.attr('onclick', `return ${subscribeAction};`);
                    subscribeButton.html(subscribeText);
                    subscribeButton.toggleClass('primary', !canRemoveOrMove);
                    subscribeButton.toggleClass('alert', canRemoveOrMove);

                    reservationButton.attr('onclick', `return ${moveAction};`);
                    reservationButton.html(moveText);
                    reservationButton.toggleClass('secondary', !canRemoveOrMove);
                    reservationButton.toggleClass('primary', canRemoveOrMove);
                });
            });
        }
    });
    return false;
}
function save_student_notes(appointment_id, contact_id, notes) {
    const $ = jQuery.noConflict();
    $.post({
        url: '/calendar/saveStudentNotes2/' + appointment_id + '/' + contact_id,
        data: {notes}
    })
}
function edit_appointment(appointment_id, callback, module) {
    const $ = jQuery.noConflict();

    if (module === undefined) {
        module = window.module;
    }
    if (module === undefined) {
        console.error('No module specified');
        return;
    }

    $.squdeAjaxPopup({
        url: '/calendar/edit-appointment/'+appointment_id,
        onOpen: function(elm, popup) {
            reload_room_checkers(elm, appointment_id);
            reload_datepickers();
            reload_timepickers();

            runTeacherAppointmentApplicationUI(elm);

            if (module === 'courses') {
                edit_course_appointment(appointment_id, elm,popup, callback);
            }
        }
    });
    return false;
}
function delete_appointment(id) {
    var $ = jQuery.noConflict();
    custom_delete_with_confirmation('/calendar/appointments/delete',id, "Weet u zeker dat u dit agenda-item wilt verwijderen?", 'appointment', function() {
        $('[data-object-type=\'appointment\'][data-id=\''+id+'\'').remove();
        if($('.calendar-wrapper').length > 0) {
            $('body').isLoading();
            location.reload();
        } else {
            reload_location_if_needed();
        }
    });

    return false;
}
function print_layout(type, appointment_id, url) {
    const $ = jQuery.noConflict();

    if(type === 'default') {
        window.location.replace(url);
    } else {
        const name = type.substr(0,1).toUpperCase() + type.substr(1) + 's';
        const lowerName = name.toLowerCase();
        $.squdeAjaxPopup({
            url: '/calendar/getPrint' + name + 'Form/' + appointment_id,
            onOpen: function(elm, popup) {

                elm.find('form').submit(function(e) {
                    e.preventDefault();
                    var data = $(this).serializeJSON();

                    if(!data['print_' + lowerName]) {
                        elm.find('.show-on-error').show();
                    } else {
                        elm.find('.show-on-error').hide();

                        const obj = {};
                        obj[lowerName] = data['print_' + lowerName];

                        var params = $.param(obj);
                        popup.close();

                        url = url+'?'+params;

                        if(window.pressed('alt')) {
                            window['pressed_keys'] = [];
                            url = url+'&stream=true';
                            window.open(url);
                        } else {
                            window.location.replace(url);
                        }
                    }
                });
            }
        });
    }
    return false;

}
function get_calendar_module_setting(module, setting) {
    var obj = {
        courses: {
            addWizardUrl: '/calendar/add'
        },
        inspections: {
            addWizardUrl: '/inspections/calendar/add'
        }
    };
    return obj[module][setting];
}
function mass_unsubscribe(appointmentId, students) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: `/calendar/unsubscribeStudents/${appointmentId}`,
        data: { students },
        onOpen: function(elm, popup) {
            elm.find('form').ajaxFormSubmit(function(e) {
                squde_reload_for_flashes(() => {
                    popup.close();
                    const table = $('.subscribed-contacts-table');
                    table.find(':checked').removeAttr('checked').trigger('change');
                    reload_location_if_needed(false);
                })
            });
        }
    });
    return false;
}
function mass_move_students(appointmentId, students) {
    const $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: `/calendar/moveStudents/${appointmentId}`,
        data: { students },
        onOpen: function(elm, popup) {
            const appointmentsPerPage = 30;
            let currentPageOfAppointments = 1;
            let reachedEnd = false;
            elm.find('[data-course-selector]').courseSelector();
            const courseIdOfThisAppointment = parseInt(elm.find('input[name="appointment_course_id"]').val());
            const freeSpace = elm.find('input[name="students\[\]"]').length;

            const selector = elm.find(':input[name="course_id"]');
            elm.find('input[name="what_appointments"]').change(function () {
                const whatAppointments = elm.find('input[name="what_appointments"]:checked').val();
                elm.find('input[name="remove_from_all_appointments"]').val(whatAppointments === 'all' ? 1 : 0);
                if (whatAppointments !== 'all') {
                    selector
                        .attr('data-current-value', courseIdOfThisAppointment)
                        .attr('disabled', 'disabled')
                        .courseSelector();
                } else {
                    selector
                        .removeAttr('disabled')
                        .courseSelector();
                }
            });
            const appointmentsWrapper = elm.find('.appointments-wrapper');
            const appointmentPrototype = elm.find('.appointment-option.prototype');
            const historicalCourses = elm.find('[name=historical_courses]');

            const fetchAppointments = () => {
                elm.isLoading();
                elm[0].ajax = $.getJSON('/calendar/moveStudentsAppointments/', {
                    freeSpace,
                    page: currentPageOfAppointments,
                    exceptFor: appointmentId,
                    courseId: selector.val(),
                    whatAppointments: elm.find('input[name="what_appointments"]:checked').val(),
                    historicalCourses: historicalCourses.is(':checked'),
                }, function(data) {

                    console.log({ data });
                    reachedEnd = data.length < appointmentsPerPage;
                    elm.doneLoading();

                    const emptyResult = currentPageOfAppointments === 1 && data.length === 0;
                    appointmentsWrapper.toggleClass('empty', emptyResult);
                    appointmentsWrapper.find('.show-if-result-0').toggle(emptyResult);
                    elm.find('[type="submit"]').prop('disabled', () => {
                        return emptyResult;
                    });


                    data.forEach(function (row, rowIndex) {
                        const clone = appointmentPrototype.clone();
                        clone.removeClass('prototype');
                        const inputClone = appointmentPrototype.prev().clone();

                        const descriptionWrapper = clone.find('.description-wrapper');
                        descriptionWrapper.empty();
                        const spaceWrapper = clone.find('.space-wrapper');
                        spaceWrapper.empty();
                        const dateTimeWrapper = clone.find('.date-time-wrapper');
                        dateTimeWrapper.empty();
                        const locationWrapper = clone.find('.location-wrapper');
                        locationWrapper.empty();

                        const inCompanyWrapper = clone.find('.incompany-names span');
                        inCompanyWrapper.empty();
                        clone.find('.incompany-column').toggle(row[0].incompany);
                        inCompanyWrapper.append(row[0].incompany ? (row[0].incompany_names).sort().join(', ') : '');

                        inputClone.attr('value', row[0].appointment_group_id);
                        inputClone.attr('id', 'appointment_group_' + row[0].appointment_group_id);


                        clone.attr('for', 'appointment_group_' + row[0].appointment_group_id);

                        inputClone.change(function() {
                            if (!$(this).is(':checked')) return;
                            elm.find('.student-components-table').each(function() {
                                const tbody = $(this);
                                tbody.find('tr:not(:nth-child(1))').remove();

                                row.forEach((appointment, index) => {
                                    const findIndex = index + 1;
                                    let tr = tbody.find(`tr:nth-child(${findIndex})`);
                                    if (tr.length === 0) {
                                        tr = tbody.find('tr:nth-child(1)').clone();
                                        tbody.append(tr);
                                    }
                                    tr.find('input').attr('value', appointment.id);
                                    // Disable / enable the input through styles, so the content still will get sent
                                    if (elm.find('input[name="what_appointments"][value="all"]').is(':checked')) {
                                        tr.find('input').removeAttr('style');
                                    } else {
                                        tr.find('input').css({
                                            pointerEvents: 'none',
                                            filter: 'grayscale(1)',
                                            opacity: 0.5,
                                        });
                                    }
                                    tr.find('.component-description').html(appointment.course_component.description);
                                    const start = new Date(appointment.start_datetime);
                                    const end = new Date(appointment.end_datetime);
                                    const startString = `${leadingZero(start.getDate())}-${leadingZero(start.getMonth() + 1)}-${start.getFullYear()} ${leadingZero(start.getHours())}:${leadingZero(start.getMinutes())}`;
                                    let endString = `${leadingZero(end.getDate())}-${leadingZero(end.getMonth() + 1)}-${end.getFullYear()} ${leadingZero(end.getHours())}:${leadingZero(end.getMinutes())}`;
                                    if (startString.substr(0, 10) === endString.substr(0, 10)) {
                                        endString = endString.substr(11);
                                    }
                                    tr.find('.component-start').html(startString);
                                    tr.find('.component-end').html(endString);
                                });
                            });
                        });

                        appointmentsWrapper.append(inputClone).append(clone);
                        if (rowIndex === 0) {
                            inputClone.prop('checked', true).trigger('change');
                        }

                        row.forEach((appointment) => {
                            descriptionWrapper.append('<span>' + appointment.description + '</span>');
                            spaceWrapper.append('<span>' + (appointment.max_count - appointment.student_count) + '</span>');
                            moment.locale('nl');
                            const date = moment(appointment.start_date, 'DD-MM-YYYY');
                            const dayName = date.format('dddd DD-MM-YYYY');

                            dateTimeWrapper.append(`<span>${dayName} <small>${appointment.start_time} - ${appointment.end_time}</small></span>`);
                            const citySpan = makeAppointmentLocationLink(appointment);
                            locationWrapper.append(citySpan);
                        });


                        clone.show();
                    });
                });
            };

            const resetAndFetch = () => {
                if (elm[0].ajax) {
                    elm[0].ajax.abort();
                }
                currentPageOfAppointments = 1;

                appointmentPrototype.nextAll().not('.show-if-result-0').remove();
                fetchAppointments();
            }

            selector.change(resetAndFetch);
            historicalCourses.change(function() {
                const sendMessageInput = elm.find('input[type="checkbox"][name="send_message"]');
                const historicalFilterOn = $(this).is(':checked');
                if (historicalFilterOn) {
                    sendMessageInput.attr('disabled', 'disabled');
                } else {
                    sendMessageInput.removeAttr('disabled');
                }
                elm.find('.send-message-row').toggle(!historicalFilterOn);

                resetAndFetch();
            });


            appointmentsWrapper.bind('scroll', function() {
                if (reachedEnd) return;
                const scrollTop = $(this).scrollTop();
                const innerHeight = $(this)[0].scrollHeight;
                const outerHeight = $(this).outerHeight();

                const endBreakpoint = innerHeight - 50;
                if ((scrollTop + outerHeight) > endBreakpoint) {
                    if (elm[0].ajax.readyState === 4) {
                        currentPageOfAppointments = currentPageOfAppointments + 1;
                        fetchAppointments();
                    }
                }
            });

            elm.find('form.choose-appointments-to-move-to').submit(function(e) {
                e.preventDefault();
                ajax_popup_scroll_to_next_screen();
            });

            elm.find('form.move-the-students').ajaxFormSubmit(function(e) {
                squde_reload_for_flashes(() => {
                    popup.close();
                    const table = $('.subscribed-contacts-table');
                    table.find(':checked').removeAttr('checked').trigger('change');
                    reload_location_if_needed(false);
                })
            });
        }
    });
    return false;
}
function init_notes_editing(elm) {
    const w = elm.find('.appointment-notes-wrapper');
    if (w.length === 0) return;

    const read = w.find('.read');
    const write = w.find('.write');
    const add = w.find('.add-notes');
    const cancel = write.find('.cancel-edit');
    const form = write.find('form');

    // Edit notes
    read.click(function() {
        read.toggle(); write.toggle();

        elm.find('textarea').customTextarea();
    });

    // Cancel editing
    cancel.click(function() {
        read.toggle(); write.toggle(); add.toggle();
        return false;
    });

    // Save the notes
    form.ajaxFormSubmit(function() {
        reload_location_if_needed(false);
        squde_reload_for_flashes();
    });

    // Add notes button
    add.click(function() {
        add.toggle();
        write.show();
        elm.find('textarea').customTextarea();
        return false;
    });
}
function runTeacherAppointmentApplicationUI(elm) {
    const $ = jQuery.noConflict();
    elm.find('.course-components-appointments-wrapper').find('input[name$="[has_custom_teacher_application_count]"]').unbind('change.teacher-settings').bind('change.teacher-settings', function() {
        const checked = $(this).is(':checked');
        const fieldset = $(this).parents('fieldset:first');
        const applicationCountField = fieldset.find(':input[name$="[teacher_application_count]"]');
        const column = $(this).parents('.column:first');
        column.toggleClass('medium-6', checked);
        applicationCountField.attr('disabled', !checked);
        fieldset.find('.toggle-for-custom-teacher-application-settings').toggle(checked);
    }).trigger('change.teacher-settings');
}
async function initiateComponentLogic(elm, args) {
    const {
        course,
        datetime,
        type,
        appointment
    } = args;
    let {
        contacts
    } = args;
    const $ = jQuery.noConflict();
    const components = course.components.map((component) => {
        return component.id;
    });

    contacts = _.orderBy(contacts, ['last_name', 'first_name'], ['asc', 'asc']);

    const prepareComponentsForTeachers = async () => {
        let baseData = {};
        if (elm.find('form.choose_course').length > 0) {
            baseData = elm.find('form.choose_course').serializeJSON();
        } else {
            baseData = {
                appointments: appointment.siblings,
            }
        }
        // console.log({ baseData });

        // Prepare the teachers views for these components
        const teachersForAppointmentsWrapper = elm.find('.teachers-for-appointments');

        const activeCourseComponents = course.components
            .map((component) => {
                const componentAppointmentData = Object.values(baseData.appointments).find((appointment) => {
                    return parseInt(appointment.course_component_id) === component.id;
                });
                return [component, componentAppointmentData];
            })
            .filter(([, appointmentData]) => {
                return (appointment && appointmentData) || (appointmentData && parseInt(appointmentData.enabled) === 1);
            });

        // console.log({ activeCourseComponents, course });

        let allOccupationsAtTimes = [];

        const chunkSize = 5;
        for (let i = 0; i < activeCourseComponents.length; i += chunkSize) {
            const chunk = activeCourseComponents.slice(i, i + chunkSize);
            const occupationsAtTimes = await Promise.all(
                chunk
                    .map(([, appointmentData]) => $.getJSON('/calendar/getOccupations', {
                            from: appointmentData.start_datetime,
                            to: appointmentData.end_datetime,
                            except: appointmentData.id ? appointmentData.id : null,
                        })
                    ));
            allOccupationsAtTimes = [...allOccupationsAtTimes, ...occupationsAtTimes];
        }

        teachersForAppointmentsWrapper.children(':not(:nth-child(1))').remove();

        activeCourseComponents
            .forEach(([component, appointmentData], index) => {
                // Make sure you add the needed repeat-item
                let teacherComponentWrapper = teachersForAppointmentsWrapper.children(`:nth-child(${index + 1})`);
                if (teacherComponentWrapper.length === 0) {
                    teachersForAppointmentsWrapper.trigger('add-an-item');
                    teacherComponentWrapper = teachersForAppointmentsWrapper.children(`:nth-last-child(1)`);
                }

                // Extract the date and time from the set items
                let date, time;
                if (typeof appointmentData.start_datetime === 'object') {
                    [date, time] = Object.values(appointmentData.start_datetime);
                } else {
                    [date, time] = [appointmentData.start_date, appointmentData.start_time];
                }

                // Set the title of each component to the component description + date + time
                teacherComponentWrapper.find('legend').html(`${date} ${time} // ${component.description}`);

                // Save the id of the given appointment
                if (appointmentData.id) {
                    teacherComponentWrapper.find('input.appointment-id-input').val(appointmentData.id);
                }

                // Retrieve the occupations
                const occupations = allOccupationsAtTimes[index];

                // Put all responsibles of this appointment in an array
                let appointmentResponsibles = appointmentData.responsibles ? appointmentData.responsibles : [];

                // Respond to skills changes
                const skillsTagsWrapper = teacherComponentWrapper.find('.tag-input-skills');

                // Respond to search changes
                const nameSearchbars = teacherComponentWrapper.find('input[type="search"]');


                const renderTeachers = function() {
                    // Retrieve teachers with these skills + within search
                    const skills = _.uniq(skillsTagsWrapper.getTags().map((skillId) => parseInt(skillId)));
                    (() => {
                        teacherComponentWrapper.find('.teacher-role-wrapper').each(function() {
                            const teacherRoleWrapper = $(this);
                            const nameSearchbar = teacherRoleWrapper.find('input[type="search"]');
                            const searchValue = nameSearchbar.val();
                            const roleId = parseInt(teacherRoleWrapper.attr('data-role-id'));
                            const roleName = teacherRoleWrapper.attr('data-role-name');

                            // Get teachers saved on this appointment
                            const savedResponsibles = appointmentResponsibles.filter((responsible) => {
                                return responsible.pivot.role_id === roleId;
                            })

                            const teacherList = teacherRoleWrapper.find('.teachers-list');
                            teacherRoleWrapper.find('.in-selection').removeClass('in-selection');

                            teacherList.find('input[type="checkbox"]').each(function() {
                                const input = $(this);
                                const teacherWrapper = input.parents('.teacher-wrapper');
                                if (teacherWrapper.hasClass('currently-saved')) {
                                    return;
                                }
                                if (!input.is(':checked')) {
                                    if (teacherWrapper.index() > 0) {
                                        teacherWrapper.remove();
                                    } else {
                                        teacherWrapper.hide();
                                    }
                                } else {
                                    teacherWrapper.addClass('in-selection');
                                }
                            });
                            contacts
                                .filter((contact) => {
                                    return contact.roles
                                        .map((role) => role.id)
                                        .includes(roleId);
                                })
                                .filter((contact) => {
                                    if (!teacherRoleWrapper.is('[data-filterable]')) {
                                        return true;
                                    }
                                    return savedResponsibles.find((responsible) => responsible.id === contact.id) ||
                                        contact.skills
                                            .map((skill) => skill.id)
                                            .filter((contactSkill) => {
                                                return skills.includes(contactSkill);
                                            }).length === skills.length;
                                })
                                .filter((contact) => {
                                    return searchValue.length === 0 || contact.messageName.toLowerCase().split(searchValue.toLowerCase()).length > 1;
                                })
                                .forEach(function(contact, index) {
                                    const id = contact.id;
                                    const name = contact.messageName;

                                    // Retrieve these contact occupations that are in the way
                                    const contactOccupations = occupations.filter((occupation) => occupation.contact_id === id);

                                    // Is currently saved or not
                                    const isInSavedSet = savedResponsibles.filter((responsible) => responsible.id === id).length > 0;

                                    // Skip if you find this person in the list of already saved people (on front of the list)
                                    let foundInSavedSet = teacherList.find(`.currently-saved input[value="${id}"]`).length > 0;
                                    if (foundInSavedSet) {
                                        return;
                                    }

                                    // See if it's already in place, if so, remove that wrapper
                                    let prevTeacherWrapper = teacherList.find(`.in-selection input[value="${id}"]:checked`).parents('.teacher-wrapper');
                                    prevTeacherWrapper.removeClass('in-selection');
                                    const isChecked = prevTeacherWrapper.length > 0;
                                    if (isChecked && prevTeacherWrapper.index() > 0) {
                                        prevTeacherWrapper.remove();
                                    }

                                    const preferredIndex = index + 1 + teacherList.find('.in-selection').length + teacherList.find('.currently-saved').length;
                                    let teacherWrapper = teacherList.children(`:nth-child(${preferredIndex})`);
                                    if (teacherWrapper.length === 0) {
                                        teacherWrapper = teacherList.children(`:nth-child(1)`).clone();
                                        teacherWrapper.removeClass('currently-saved');
                                        teacherWrapper.removeClass('in-selection');
                                        teacherList.append(teacherWrapper);
                                    }

                                    teacherWrapper.find('.change-times-button').removeClass('edit-time-event-init');

                                    if (isInSavedSet) {
                                        teacherWrapper.addClass('currently-saved');
                                        teacherWrapper.prependTo(teacherList);
                                        const checkbox = teacherWrapper.find('input[type="checkbox"]');
                                        checkbox[0].checked = true;
                                        checkbox.change(function() {
                                            if (!$(this).is(':checked')) {
                                                appointmentResponsibles = appointmentResponsibles.filter((savedResponsible) => (savedResponsible.id !== id && savedResponsible.pivot.role_id !== roleId));
                                                teacherWrapper.removeClass('currently-saved');
                                            }
                                        });
                                    } else {
                                        teacherWrapper.find('input[type="checkbox"]')[0].checked = isChecked;
                                    }
                                    teacherWrapper.removeAttr('style');

                                    const uid = get_unique_id();
                                    const teacherInputs = teacherWrapper.find('input[name^="appointments"]');

                                    teacherInputs.each(function() {
                                        const input = $(this);
                                        const inputName = input.attr('name').split(']');
                                        inputName[0] = `appointments[${teacherComponentWrapper.index()}`;
                                        input.attr('name', inputName.join(']'));
                                    })


                                    // For non-teachers, you can change the time
                                    if (roleName !== 'teacher') {
                                        const timeFromInput = teacherWrapper.find('.time-from');
                                        const timeToInput = teacherWrapper.find('.time-to');
                                        const startTime = appointmentData.start_time ? appointmentData.start_time : appointmentData.start_datetime[1];
                                        const endTime = appointmentData.end_time ? appointmentData.end_time : appointmentData.end_datetime[1];
                                        let responsibleStartTime = startTime;
                                        let responsibleEndTime = endTime;

                                        const savedResponsible = savedResponsibles.find(responsible => responsible.id === id);
                                        const pivot = savedResponsible ? savedResponsible.pivot : undefined;
                                        if (pivot && pivot.starts_at && pivot.ends_at) {
                                            const [startHour, startMinute] = pivot.starts_at.split(':');
                                            responsibleStartTime = [startHour, startMinute].join(':');
                                            const [endHour, endMinute] = pivot.ends_at.split(':');
                                            responsibleEndTime = [endHour, endMinute].join(':');
                                        }

                                        timeFromInput.val(responsibleStartTime);
                                        timeFromInput.attr('data-original-value', startTime);
                                        timeToInput.val(responsibleEndTime);
                                        timeToInput.attr('data-original-value', endTime);

                                        // teacherWrapper.find('.custom-time').toggle(responsibleStartTime !== startTime || responsibleEndTime !== endTime);
                                        timeFromInput.trigger('change');

                                        [timeFromInput, timeToInput].forEach((input) => {
                                            const name = input.attr('name');
                                            const parts = name.split('[');
                                            parts[3] = `${id}]`;
                                            const newName = parts.join('[');
                                            input.attr('name', newName);
                                        })
                                    }

                                    const label = teacherWrapper.find('label');
                                    const warningContent = teacherWrapper.find('.warning-content');
                                    const checkboxInput = teacherWrapper.find('input[type="checkbox"]');

                                    checkboxInput.removeAttr('disabled');
                                    checkboxInput.attr('id', uid);
                                    label.attr('for', uid);
                                    checkboxInput.val(id);
                                    teacherWrapper.attr('title', name);
                                    label.html(name);
                                    label.show();


                                    if (contactOccupations.length > 0) {
                                        label.addClass('show-warning-sign');
                                        warningContent.find('.contact-name').html(contact.messageName);
                                        warningContent.find('.plural').toggle(contactOccupations.length > 1);
                                        warningContent.find('.links').html(contactOccupations.map((appointment) => {
                                            return `<a onclick="return view_appointment(${appointment.id})">${appointment.description}</a>`;
                                        }).join(', '));
                                    } else {
                                        label.removeClass('show-warning-sign');
                                    }

                                    teacherWrapper.find('a').click(function(e) {
                                        e.preventDefault();
                                        view_contact(id, {});
                                    });
                                });
                            let shouldShow = false;
                            teacherList.find('.teacher-wrapper').each(function() {
                                if ($(this).css('display') !== 'none') {
                                    shouldShow = true;
                                }
                            });
                            const foundTeachers = shouldShow;
                            if (searchValue.length > 0) {
                                shouldShow = true;
                            }

                            teacherRoleWrapper.toggle(shouldShow);

                            teacherRoleWrapper.find('.no-search-results-wrapper').toggle(searchValue.length > 0 && !foundTeachers);
                        });

                        init_edit_responsible_times(elm)
                    })()
                };

                skillsTagsWrapper.unbind('changeTags').bind('changeTags', renderTeachers);
                nameSearchbars.bind('keyup keydown', renderTeachers)

                // Set the skills of this component
                setTimeout(() => {
                    skillsTagsWrapper.setTags(component.skills);
                }, 1);
            });
        // console.log('done loading stuff');
    }

    if (!appointment) {
        await (async () => {
            const submit_button = elm.find('[type=submit]');
            const fieldsetCollection = await $.get('/calendar/getPredictedComponentAppointmentsTable',{datetime: datetime.getTime() / 1000, components: components.join(','), type});
            submit_button.attr('disabled',false);
            elm.find('.course-components-appointments-wrapper').html(fieldsetCollection);
            elm.find('.course-components-appointments').show();

            // instead input elm.find('.course-components-appointments-wrapper').find('input') give me the input that ends with [enabled] in the name

            runTeacherAppointmentApplicationUI(elm);

            elm.find('.course-components-appointments-wrapper').find('input[name$="[enabled]"]').unbind('change.reload-everything').bind('change.reload-everything', async function() {
                const fieldset = $(this).parents('fieldset:first');
                const checked = $(this).is(':checked');
                const allOtherInputs = fieldset.find(':input:not([name$="[enabled]"]):not([name$="[teacher_application_count]"])');
                allOtherInputs.attr('disabled', !checked);
                fieldset.find('.row.disabled').find(':input').attr('disabled', true);

                const customTeacherCountCheckbox = fieldset.find('input[name$="[has_custom_teacher_application_count]"]');

                customTeacherCountCheckbox.attr('checked', false);
                customTeacherCountCheckbox.trigger('change.teacher-settings');

                submit_button.attr('disabled', fieldset.parents('.repeats-wrapper').find('input[name$="[enabled]"]:checked').length === 0);
            });

            reload_datepickers();
            reload_timepickers();
            reload_room_checkers(elm);
        })();

        elm.find('form.choose_teachers').parents('.scroll-screen').unbind('beforeScroll').bind('beforeScroll', async function() {
            elm.isLoading();
            await prepareComponentsForTeachers();
            elm.doneLoading();
        });
    } else {
        elm.on('openTab', async function(event, link, initial) {
            if (link === 'responsibles') {
                elm.isLoading();
                await prepareComponentsForTeachers();
                elm.doneLoading();
            }
        });
        // Click active link again
        elm.find('.left-popup-menu li.active a').click();
    }



}
function makeAppointmentLocationLink(appointment) {
    const $ = jQuery.noConflict();
    const citySpan = $('<span />');

    if (parseInt(appointment.course.online) === 0) {
        const cityLink = $('<a />');
        cityLink.attr('href', appointment.maps_url);
        cityLink.attr('target', '_blank');

        const address = [appointment.street, appointment.street_no + appointment.street_no_adding].join(' ');
        cityLink.html([appointment.address_name, address, appointment.city].filter((elm) => elm.length > 0).join(', '));
        citySpan.html(cityLink);
    }
    return citySpan;
}
function initPresencePassLogic(elm) {
    const $ = jQuery.noConflict();
    jQuery(elm).find('table').each(function() {
        const table = $(this);
        const applyPresencePassLogic = (table) => {
            // If someone sets presence to something other than 1, he's not passed
            table.find('select[name^="present_students"]').unbind('change.presence-pass').bind('change.presence-pass', function() {
                const select = $(this);
                if (select.val() === '') {
                    select.parents('tr').find(`select[name^="passed_students"]`).val('');
                } else if (select.val() === '0') {
                    select.parents('tr').find(`select[name^="passed_students"]`).val(0);
                }
            });

            // If you set someone to passed, he's also present right away
            // inputs are named like this: passed_students[432][1524]
            table.find('select[name^="passed_students"]').unbind('change.presence-pass').bind('change.presence-pass', function() {
                const select = $(this);
                if (select.val() === '') {
                    return;
                }
                select.parents('tr').find(`select[name^="present_students"]`).val(1).trigger('change');
            });

            // Apply mass actions
            (() => {
                // Apply mass actions style
                const wrapper = table.closest('fieldset').find('.apply-to-all-students-wrapper');
                wrapper.css({
                    display: 'flex',
                    gap: '1rem',
                    alignItems: 'center',
                    marginBottom: '1rem',
                });
                const select = wrapper.find('select.apply-to-all-students');
                select.css({
                    width: 'auto',
                    margin: 0
                })

                // Reflect selection in mass action text
                const reflectSelection = () => {
                    const hasSelection = table.find('input[type="checkbox"]:checked').length > 0;
                    const label = wrapper.find('label');
                    label.find('.no-selection').toggle(!hasSelection);
                    label.find('.has-selection').toggle(hasSelection);
                }
                table.find('tbody input[type="checkbox"]').unbind('change.presence-pass').bind('change.presence-pass', function() {
                    reflectSelection()
                });
                reflectSelection();

                // Do mass actions
                select.unbind('change.presence-pass').bind('change.presence-pass', function() {
                    const select = $(this);
                    const action = select.val();
                    if (action === '') {
                        return;
                    }
                    const hasSelection = table.find('input[type="checkbox"]:checked').length > 0;
                    const trSelector = hasSelection ? 'tbody tr:has(input[type="checkbox"]:checked)' : 'tbody tr';

                    table.find(trSelector).each(function() {
                        const tr = $(this);
                        const selector = action === 'present' ? 'present_students' : 'passed_students';

                        tr.find(`select[name^="${selector}"]`).val(1).trigger('change');
                    });
                    select.val('');
                    table.find('input[type="checkbox"]').removeAttr('checked').trigger('change');
                });
            })();
        }
        table.unbind('onReload.presence-pass').bind('onReload.presence-pass', function() {
           applyPresencePassLogic(table);
        });
        applyPresencePassLogic(table);
    });
}
